export default {
  disclaimers:{
    aggreen:'我已閱讀並同意',
    aggereen_title:'免責聲明',
    title:'免責聲明',
    nav_title:'投資者在使用本交易系統前，請仔細閱讀以下免責聲明:',
    t0:'如果客戶透過電子服務進行買賣，客戶便須承受該電子服務系統帶來的風險，包括有關系統硬體和軟件可能會失靈的風險。系統失靈可能會導致客戶的買賣盤不能根據指示執行，甚或完全不獲執行;',
    t1:'由於未可預計的網絡擠塞和其他原因，電子服務可能並不可靠的，及存在通過電子服務進行的交易在傳輸和接收客戶的指示或其他資訊過程中可能會被耽誤、延遲執行客戶的指示或有關指示以有別於客戶發出指示時的市價執行、指示在傳輸時被中斷或停頓等風險。',
    t2:'在通訊過程中也存在誤解或錯誤的風險，以及在發出了指示後，通常也不一定可以取消。由於此類中斷、耽誤或被第三方進入而使客戶遭受的任何損失，本公司概不承擔責任。如果客戶不準備接受此類中斷或耽誤引致的風險，客戶不應透過電子服務作出任何指示;',
    t3:'通過電子服務向客戶提供的市場數據和其他資訊可能是本公司從第三者獲得的。雖然本公司相信這些數據和資訊是可靠的，但本公司或該等第三者都不會保證這些數據和資訊的準確性、完整性和即時性。',
    t4:'客戶應自行對交易決策和操作負責，不得歸咎於本交易系統。客戶應遵守相關法律法規和交易所規則，對自身行為承擔全部責任。',
    t5:'本交易系統提供的所有信息和分析僅供參考，不構成任何投資建議。客戶應獨立做出投資決策，自行承擔相應的交易風險。'
  }
}
